<template>
  <div class="">
    <div
      class="column columns is-gapless is-multiline is-vcentered is-narrow is-padding-top-large is-padding-bottom-large">
      <div class="column is-6">
        <v-input id="name" name="name" :model="newName" @input="val => newName = val" label="Nom du Pôle *"
                 v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                 data-vv-as="Nom du Pôle">
        </v-input>
      </div>
    </div>

    <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns"
         v-if="newName && newName !== pole.name">
      <div class="column is-3">
        <a class="button is-white is-uppercase is-fullwidth" @click="cancel">Annuler</a>
      </div>
      <div class="column is-6">
        <button @click="save" class="button is-success is-uppercase is-fullwidth has-text-white">Valider</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfosPanel',
    data () {
      return {
        _pole: null,
        newName: false
      }
    },
    props: {
      pole: {
        type: Object,
        required: true
      }
    },
    computed: {
      p () {
        return this._pole
      },
      polePk () {
        return this.pole.pk
      }
    },
    methods: {
      cancel () {
        this.newName = this.p.name
      },
      save () {
        let data = Object.assign({}, this._pole)
        data.name = this.newName
        this.$api.poleService.put(this.polePk, data).then(r => {
          this._pole = r.data
          this.$notify({
            type: 'is-success',
            text: 'Pôle enregistré'
          })
          this.$router.push({name: 'PoleList'})
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la modification du pôle.'
          })
        })
      }
    },
    created () {
      this._pole = Object.assign({}, this.pole)
      this.newName = this.pole.name
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pole/PolePanel/InfosPanel.vue